import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js/auto";

let delayed;
const options = {
    responsive: true,
    maintainAspectRatio: false,
    showAllTooltips: true,
    animations: {
      onComplete: () => {
        delayed = true;
      },
      delay: (context) => {
        let delay = 0;
        if (context.type === 'data' && context.mode === 'default' && !delayed) {
          delay = context.dataIndex * 300 + context.datasetIndex * 100;
        }
        return delay;
      },
      tension: {
        duration: 1000,
        easing: 'linear',
        from: 1,
        to: 0,
        loop: true
      }
    },
    scales: {
      y: {
        stacked: true,
        title: {
          display: true,
          text: ''
        }
      },
      x: {
        //display: false
      }
  },
  plugins: {
      legend: {
          display: false,
      }
  }
}

function BarChart({ chartData }) {
  return <Bar data={chartData} options={options}/>;
}

export default BarChart;
